module.exports = __webpack_public_path__ + "img/sm-x-old.d03ae457.svg";